import {SpacierArcadeGameModuleConfig} from "../../SpacierArcadeGameModuleConfig";

/**
 * Created by jonas on 2019-08-21.
 */

export interface WinterHoardWinRatioConfig extends IWinRatioConfig {

    readonly endSound?:string;
    readonly startSound?:string;
    readonly music?:string;

}


import {Timeline, TimelineLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {SpacierArcadeParsedGameData} from "../../server/data/SpacierArcadeParsedGameData";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SpacierArcadeSoundConfig} from "../../SpacierArcadeSoundConfig";

export class BigWinStep implements GameRoundPresentation {

    stagger?:number;
    abortStagger?:number;
    private _isFirstStep:boolean;
    private _fromRatioConfig:IWinRatioConfig;
    private _toRatioConfig:IWinRatioConfig;
    private _hasWin:boolean;
    private _countFrom:number;
    private _countTo:number;
    private _lastLevel:boolean;
    private _lastLevelCount:number;
    private _lastLevelRemainderRatio:number;
    private _stepSound:string;


    constructor(fromRatioConfig:IWinRatioConfig, toRatioConfig:IWinRatioConfig, isFirstStep:boolean = false, stepSound:string, stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
        this._fromRatioConfig = fromRatioConfig;
        this._toRatioConfig = toRatioConfig;
        this._isFirstStep = isFirstStep;
        this._stepSound = stepSound;
    }

    public prepare(data:SpacierArcadeParsedGameData):void {
        this._hasWin = false;
        this._countFrom = 0;
        this._countTo = 0;
        this._lastLevel = false;
        this._lastLevelCount = 0;
        this._lastLevelRemainderRatio = 0;

        if(data instanceof ParsedGameData) {
            if(data.totalSpinWinnigs <= 0) {
                return;
            }

            const currentWinRatio = data.totalSpinWinnigs / data.playedBetValue;
            this._hasWin = currentWinRatio >= this._toRatioConfig.ratio;
            this._countFrom = data.playedBetValue * this._fromRatioConfig.ratio;
            this._countTo = data.playedBetValue * this._toRatioConfig.ratio;
            if(data.currentTotalWinRatioConfig && data.currentTotalWinRatioConfig == this._toRatioConfig) {
                this._lastLevel = true;
                this._lastLevelCount = data.totalSpinWinnigs;
                const remainder:number = this._lastLevelCount - this._countTo;
                this._lastLevelRemainderRatio = remainder / data.playedBetValue;

                this._countTo =  this._lastLevelCount;
            }
        }
    }


    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        if(!this._hasWin || this.isLevelWinSmall(data)) {
            return null;
        }

        const tl:TimelineLite = new TimelineLite();
        const winTextStart:Timeline = SpacierArcadeGameModuleConfig.saBigWinView.getStartAnimation(this._toRatioConfig);
        const count:Timeline = SpacierArcadeGameModuleConfig.saCountupView.getWinStepAnimation(this._countFrom, this._countTo, this._toRatioConfig.duration);
        if(this._isFirstStep) {
            const initTl: TimelineLite | null = SpacierArcadeGameModuleConfig.saInitialWinPresentation.getAnimation(data);

            tl.add([initTl,
                () => {
                    SlotGame.sound.fadeAmbience(0, 1000);
                    SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.BIG_WIN)
                },
            ], 0);
        }

        tl.add([
            () => {
                SlotGame.sound.playEffect(this._stepSound);
            },
            count,
            winTextStart

        ], this._isFirstStep? tl.totalDuration() - 1 : 0);
        tl.add(() => {
            SlotGame.sound.stopEffect(SpacierArcadeSoundConfig.instance.BIG_WIN_COUNTUP)
        });
        return tl;
    }

    private isLevelWinSmall(data:SpacierArcadeParsedGameData):boolean{
        if (this._toRatioConfig.ratio === 15) {
            return false;
        }
        var fromValue = data.playedBetValue * this._fromRatioConfig.ratio;
        var toValue = data.totalSpinWinnigs;
        return (toValue - fromValue) <= (fromValue * 0.1);
    }

    public abort(isActive:boolean):Timeline | null {
        if(!this._hasWin) {
            return null;
        }

        const tl:TimelineLite = new TimelineLite();
        const winText = SpacierArcadeGameModuleConfig.saBigWinView.abort(this._toRatioConfig);

        let count;
        if(this._lastLevel) {
            count = SpacierArcadeGameModuleConfig.saCountupView.abort(this._lastLevelCount);
        }
        else {
            // count = SpacierArcadeGameModuleConfig.saCountupView.abort(this._countTo);
        }

        tl.add([
            winText
        ]);
        tl.add(() => {
            SlotGame.sound.stopEffect(SpacierArcadeSoundConfig.instance.BIG_WIN_COUNTUP)
        });
        return tl;
    }

    private playSound(config:IWinRatioConfig) {
        // SlotGame.sound.playEffect(config.sound!);
    }
}